import { connect } from 'react-redux';

import { DELETE_ROOM_OF_PLACE, GET_ROOMS_OF_PLACE } from 'store/room/actionTypes';
import { CLOSE_MODAL } from 'store/global/modal/actionTypes';

import RoomsOfPlace from './RoomsOfPlace';

const mapStateToProps = (state) => ({
  isLoadingGetRoomsOfPlace: state.Room.isLoadingGetRoomsOfPlace,
  isLoadingDeleteRoomOfPlace: state.Room.isLoadingDeleteRoomOfPlace,

  roomsOfPlace: state.Room.roomsOfPlace,
  modalType: state.Modal.modalType,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetRoomsOfPlace: (payload) => dispatch({
    type: GET_ROOMS_OF_PLACE,
    payload,
  }),

  actionDeleteRoomOfPlace: (payload) => dispatch({
    type: DELETE_ROOM_OF_PLACE,
    payload,
  }),

  actionCloseModalCreateRoomSuccess: () => dispatch({
    type: CLOSE_MODAL,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(RoomsOfPlace);
